import { render, staticRenderFns } from "./SampleCompanyReportLayout.vue?vue&type=template&id=0cea3e4b"
import script from "./SampleCompanyReportLayout.vue?vue&type=script&lang=js"
export * from "./SampleCompanyReportLayout.vue?vue&type=script&lang=js"
import style0 from "./SampleCompanyReportLayout.vue?vue&type=style&index=0&id=0cea3e4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports